module.exports = __webpack_public_path__ + "static/media/hands-holding-heart.86dd2e24.svg";